<template>
  <section class="container">
    <the-title title="my data" backTitle="personal"></the-title>
    <base-card class="border">
      <base-spinner v-if="isLoading"></base-spinner>
      <form @submit.prevent="createProject">
        <div class="form-item">
          <input
            type="text"
            placeholder="project title"
            v-model.trim="ProjectData.title"
            required=""
          />
        </div>
        <!-- <div class="form-item">
           <textarea v-model.trim="ProjectData.Description" required class="w-[80%]  bg-[#1c1a1a] rounded-xl text-white p-4" placeholder="project Des " cols="30" rows="10  "></textarea>
          </div> -->
        <div class="form-item">
          <div
            id="editor-container"
            v-html="ProjectData.description"
            class="w-full h-64 rounded-lg shadow-xl text-white outline-none py-4 px-3"
          ></div>
        </div>
        <div class="form-item flex py-2 w-[80%] m-auto my-2">
          <input
            @change="handelImage"
            type="file"
            id="image"
            ref="imageRef"
            class="m-auto w-3/4"
          />
          <div class="py-2 w-1/4" v-if="ProjectData.imgByte">
            <img
              :src="`data:image/png;base64,${ProjectData.imgByte}`"
              alt="uploadedImage"
            />
          </div>
        </div>
        <div class="form-item">
          <input
            type="text"
            placeholder="project Link"
            v-model.trim="ProjectData.projectLink"
            required
          />
        </div>
        <div class="form-item">
          <input
            type="text"
            placeholder="Code Link"
            v-model.trim="ProjectData.codeLink"
          />
        </div>
        <div class="form-item">
          <div>
            <input
              type="text"
              placeholder="technology"
              v-model.trim="technology"
            />
            <button
              @click.prevent="addTech"
              class="text-black bg-yellow py-2 px-3 rounded-md cursor-pointer"
              :disabled="technology ? false : true"
            >
              Add
            </button>
          </div>
          <ul class="flex gap-2 py-3" v-if="ProjectData.technologies">
            <li
              class="text-black font-bold py-2 px-3 bg-yellow rounded-e-md"
              v-for="(tech, key) in ProjectData.technologies"
              :key="key"
            >
              {{ tech }}
            </li>
          </ul>
        </div>

        <button class="btn btn-danger" type="submit">submit</button>
      </form>
    </base-card>
  </section>
</template>

<script>
import Quill from "quill";

import "@vueup/vue-quill/dist/vue-quill.snow.css";
import BaseSpinner from "@/components/ui/BaseSpinner.vue";
export default {
  components: { BaseSpinner },
  data() {
    return {
      isLoading: false,
      selectedFile: null,
      technology: "",
      ProjectData: {
        title: "",
        description: "",
        projectLink: "",
        codeLink: "",
        technologies: [],
        imgByte: null,
      },
      // ProjectData: [],
    };
  },
  computed: {
    projectD() {
      return this.ProjectData;
    },
  },
  methods: {
    async getProjects() {
      this.isLoading = true;
      const projectId = this.$route.params.projectId;
      try {
        await this.$store.dispatch("projects/getProjects");
        const projects = this.$store.getters["projects/projects"];
        this.ProjectData = projects.find((el) => el.id === +projectId);
    
      } catch (error) {
        this.error = error.message || "Failed to get projects";
      }
      this.isLoading = false;
    },
    addTech() {
      this.ProjectData.technologies.push(this.technology);
      this.technology = "";
    },
    handelImage() {
      this.selectedFile = this.$refs.imageRef.files[0];
      //   this.ProjectData.imgByte = window.URL.createObjectURL(this.selectedFile);
    },
    async createProject() {
      const projectId = this.$route.params.projectId;
      const data = new FormData();
      data.append("id", projectId);
      data.append("title", this.ProjectData.title);
      data.append("description", this.ProjectData.description);
      data.append("files", this.selectedFile);
      data.append("projectLink", this.ProjectData.projectLink),
        data.append("codeLink", this.ProjectData.codeLink);
      data.append("technologies", this.ProjectData.technologies);

      this.isLoading = true;
      try {
        this.$store.dispatch("projects/editProject", data);
      } catch (e) {
        console.log(e.message);
      }
      this.isLoading = false;

      this.$router.replace("/portfolio");
    },
  },
  async mounted() {
    await this.getProjects();
    const quillOptions = {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"],
          [{ align: [] }],
          [{ header: [1, 2, false] }],
        ],
      },
      theme: "snow",
    };

    this.quill = new Quill("#editor-container", quillOptions);

    this.projectD;

    this.quill.on("text-change", () => {
      this.projectD.description = this.quill.root.innerHTML;
    });
  },
  created() {},
  beforeUnmount() {
    this.quill.off("text-change");
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  border-radius: 2px;
  margin: 0 auto;
}
section {
  min-height: 90vh;

  form {
    // border: 1px red solid;
    padding: 20px 10px;

    text-align: center;
    input {
      width: 60%;
      background: none;

      outline: none;
      border: none;
      border-bottom: 1px $primary solid;
      padding: 10px 10px;
      color: $light;
      margin-bottom: 1rem;
    }

    button {
      padding: 10px 40px;
    }
  }
}
</style>
